import { VIDEO_VARIANTS } from '@workspace/constants';
import { GALLERY_ASPECT, sanityHeroLoader, sanityImageSrc } from '@/sanity/lib/image';
import { HeadingType } from '@workspace/lib/heading-utils';
import { AppImage, AppVideoImage } from '@workspace/ui/common';
import { SanityImage } from '@workspace/interfaces';
import { IMAGE_DIMENSIONS } from '../useProductSummary';

interface ProductSummaryMediaProps {
  isVideo: boolean;
  video?: string;
  image?: SanityImage;
  headline?: HeadingType;
}

export function ProductSummaryMedia({ isVideo, video, image, headline }: ProductSummaryMediaProps) {
  if (isVideo && video) {
    return (
      <AppVideoImage
        variant={VIDEO_VARIANTS.VideoWithoutText}
        video={video}
        wrapperClassName="w-full h-81.75 md:h-136 md:w-136"
      />
    );
  }

  if (!image?.asset?._ref && !image?.url) {
    return <div className="w-full h-81.75 md:h-136 md:w-136 bg-light-silver flex items-center justify-center"></div>;
  }

  const altText = image?.alt || (typeof headline === 'string' ? headline : headline?.headingText || 'Product image');

  return (
    <AppImage
      loader={sanityHeroLoader(image, GALLERY_ASPECT)}
      src={sanityImageSrc(image)}
      alt={altText}
      width={IMAGE_DIMENSIONS.width}
      height={IMAGE_DIMENSIONS.height}
      className="w-full h-full object-cover"
    />
  );
}
